import React from "react";
import TableOfContents from "../../components/table-of-contents";
import { IMAGE_BASE_URL } from "../../data/baseURL";
import { overviewSubmenus } from "../../data/overview-submenu.js";
import { useScrollTop } from "../../hook/useScrollTop";
import { AboutDataContext } from "./about";

const Overview = () => {
  const {
    about_overview_asset,
    about_overview_customer,
    about_overview_do,
    about_overview_people,
  } = React.useContext(AboutDataContext);

  useScrollTop();

  return (
    <div>
      <div className="d-none d-lg-block">
        <ul className="row fs-14 bg-light list-style-none text-center gilroy-bold m-0 p-0">
          {overviewSubmenus.map((route) => (
            <li
              key={route.label}
              className="col-3 border-gray w-full submenu-link"
            >
              <a
                href={route.link}
                className="text-decoration-none py-4 d-block"
              >
                {route.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <TableOfContents routes={overviewSubmenus} />
      <section className="me-35 ms-35 mt-7">
        <p
          className="fs-16 my-5 pt-5"
          dangerouslySetInnerHTML={{ __html: about_overview_do?.heading }}
        />

        <section id="what-we-do" className="border-bottom py-5">
          <h2
            className="fs-30 pb-3"
            dangerouslySetInnerHTML={{ __html: about_overview_do?.title }}
          />
          <p
            className="fs-16 lh-30 text-align-justify"
            dangerouslySetInnerHTML={{ __html: about_overview_do?.description }}
          />
          <div className="row justify-content-center">
            <div className="col-md-4 my-5">
              <div className="bg-white rounded-lg mb-5 review-shadow position-relative h-100">
                <div className="d-flex justify-content-center">
                  <img
                    src={`${IMAGE_BASE_URL}/${about_overview_do?.image_one}`}
                    alt="user"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center mt-3 p-2">
                  <h3 className="fs-20 gilroy-bold text-secondary">
                    {about_overview_do?.tenancy_percentage_one}
                  </h3>
                  <div className="fs-12">
                    <p className="text-orange-ryb mb-0">
                      {about_overview_do?.tenancy_title_one}
                    </p>
                  </div>
                </div>
                <div className="review-card-border"></div>
              </div>
            </div>

            <div className="col-md-4 my-5">
              <div className="bg-white rounded-lg mb-5 review-shadow position-relative h-100">
                <div className="d-flex justify-content-center">
                  <img
                    src={`${IMAGE_BASE_URL}/${about_overview_do?.image_two}`}
                    alt="user"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center mt-3 p-2">
                  <h3 className="fs-20 gilroy-bold text-secondary">
                    {about_overview_do?.tenancy_percentage_two}
                  </h3>
                  <div className="fs-12">
                    <p className="text-orange-ryb mb-0">
                      {about_overview_do?.tenancy_title_two}
                    </p>
                  </div>
                </div>
                <div className="review-card-border"></div>
              </div>
            </div>

            <div className="col-md-4 my-5">
              <div className="bg-white rounded-lg mb-5 review-shadow position-relative h-100">
                <div className="d-flex justify-content-center">
                  <img
                    src={`${IMAGE_BASE_URL}/${about_overview_do?.image_three}`}
                    alt="user"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center mt-3 p-2">
                  <h3 className="fs-20 gilroy-bold text-secondary">
                    {about_overview_do?.tenancy_percentage_three}
                  </h3>
                  <div className="fs-12">
                    <p className="text-orange-ryb mb-0">
                      {about_overview_do?.tenancy_title_three}
                    </p>
                  </div>
                </div>
                <div className="review-card-border"></div>
              </div>
            </div>
          </div>
          {/* <div className="row my-5 justify-content-center">
            <div className="col-12 col-sm-6 col-md-4">
              <div className="text-center text-success">
                <h3
                  className="fs-42"
                  dangerouslySetInnerHTML={{
                    __html: about_overview_do?.tenancy_percentage_one,
                  }}
                />
                <p
                  className="fs-14 fw-bold"
                  dangerouslySetInnerHTML={{
                    __html: about_overview_do?.tenancy_title_one,
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <div className="text-center text-success">
                <h3
                  className="fs-42"
                  dangerouslySetInnerHTML={{
                    __html: about_overview_do?.tenancy_percentage_two,
                  }}
                />
                <p
                  className="fs-14 fw-bold"
                  dangerouslySetInnerHTML={{
                    __html: about_overview_do?.tenancy_title_two,
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <div className="text-center text-success">
                <h3
                  className="fs-42"
                  dangerouslySetInnerHTML={{
                    __html: about_overview_do?.tenancy_percentage_three,
                  }}
                />
                <p
                  className="fs-14 fw-bold"
                  dangerouslySetInnerHTML={{
                    __html: about_overview_do?.tenancy_title_three,
                  }}
                />
              </div>
            </div>
          </div> */}
          <div className="text-center mt-5">
            <a
              className="fs-16 text-decoration-none btn-key-company d-inline-block cursor-pointer"
              href={about_overview_do?.button_link}
              target="_blank"
              rel="noreferrer"
            >
              <span className="text-spanish-gray">&rarr;</span>
              {"  "}
              <span className="gilroy-bold text-orange-ryb">
                {about_overview_do?.button_text}
              </span>
            </a>
          </div>
        </section>
        <section id="our-assets" className="py-5 border-bottom">
          <h2
            className="fs-30"
            dangerouslySetInnerHTML={{ __html: about_overview_asset?.title }}
          />
          <p
            className="fs-16"
            dangerouslySetInnerHTML={{ __html: about_overview_asset?.text }}
          />
          <div className="row justify-content-center">
            <div className="col-md-4 my-5">
              <div className="bg-white rounded-lg mb-5 review-shadow position-relative h-100">
                <div className="d-flex justify-content-center">
                  <img
                    src={`${IMAGE_BASE_URL}/${about_overview_asset?.image_one}`}
                    alt="user"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center mt-3 p-2">
                  <h3 className="fs-20 gilroy-bold text-secondary">
                    {about_overview_asset?.site_one}
                  </h3>
                  <div className="fs-12">
                    <p className="text-orange-ryb mb-0">
                      {about_overview_asset?.site_percentage_one}
                    </p>
                  </div>
                </div>
                <div className="review-card-border"></div>
              </div>
            </div>

            <div className="col-md-4 my-5">
              <div className="bg-white rounded-lg mb-5 review-shadow position-relative h-100">
                <div className="d-flex justify-content-center">
                  <img
                    src={`${IMAGE_BASE_URL}/${about_overview_asset?.image_two}`}
                    alt="user"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center mt-3 p-2">
                  <h3 className="fs-20 gilroy-bold text-secondary">
                    {about_overview_asset?.site_two}
                  </h3>
                  <div className="fs-12">
                    <p className="text-orange-ryb mb-0">
                      {about_overview_asset?.site_percentage_two}
                    </p>
                  </div>
                </div>
                <div className="review-card-border"></div>
              </div>
            </div>

            <div className="col-md-4 my-5">
              <div className="bg-white rounded-lg mb-5 review-shadow position-relative h-100">
                <div className="d-flex justify-content-center">
                  <img
                    src={`${IMAGE_BASE_URL}/${about_overview_asset?.image_three}`}
                    alt="user"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center mt-3 p-2">
                  <h3 className="fs-20 gilroy-bold text-secondary">
                    {about_overview_asset?.site_three}
                  </h3>
                  <div className="fs-12">
                    <p className="text-orange-ryb mb-0">
                      {about_overview_asset?.site_percentage_three}
                    </p>
                  </div>
                </div>
                <div className="review-card-border"></div>
              </div>
            </div>
          </div>
          <div className="text-center mt-5">
            <a
              className="fs-16 text-decoration-none btn-key-company d-inline-block cursor-pointer"
              href={about_overview_asset?.button_link}
              target="_blank"
              rel="noreferrer"
            >
              <span className="text-spanish-gray">&rarr;</span>
              {"  "}
              <span className="gilroy-bold text-orange-ryb">
                {about_overview_asset?.button_text}
              </span>
            </a>
          </div>
        </section>
        <section id="our-customers" className="py-5 border-bottom">
          <h2
            className="fs-30"
            dangerouslySetInnerHTML={{
              __html: about_overview_customer?.heading,
            }}
          />
          <p
            className="fs-16 lh-30"
            dangerouslySetInnerHTML={{
              __html: about_overview_customer?.text,
            }}
          />
          <div className="row justify-content-center">
            <div className="col-md-4 my-5">
              <div className="bg-white rounded-lg mb-5 review-shadow position-relative h-100">
                <div className="d-flex justify-content-center">
                  <img
                    src={`${IMAGE_BASE_URL}/${about_overview_customer?.image_one}`}
                    alt="user"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center mt-3 p-2">
                  <h3 className="fs-20 gilroy-bold text-secondary">
                    {about_overview_customer?.multinational_percentage_one}%
                  </h3>
                  <div className="fs-12">
                    <p className="text-orange-ryb mb-0">
                      {about_overview_customer?.multinational_one}
                    </p>
                  </div>
                </div>
                <div className="review-card-border"></div>
              </div>
            </div>

            <div className="col-md-4 my-5">
              <div className="bg-white rounded-lg mb-5 review-shadow position-relative h-100">
                <div className="d-flex justify-content-center">
                  <img
                    src={`${IMAGE_BASE_URL}/${about_overview_customer?.image_two}`}
                    alt="user"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="text-center mt-3 p-2">
                  <h3 className="fs-20 gilroy-bold text-secondary">
                    {about_overview_customer?.multinational_percentage_two}%
                  </h3>
                  <div className="fs-12">
                    <p className="text-orange-ryb mb-0">
                      {about_overview_customer?.multinational_two}
                    </p>
                  </div>
                </div>
                <div className="review-card-border"></div>
              </div>
            </div>
          </div>
          <div className="text-center mt-5">
            <a
              className="fs-16 text-decoration-none btn-key-company d-inline-block cursor-pointer"
              href={about_overview_customer?.button_link}
              target="_blank"
              rel="noreferrer"
            >
              <span className="text-spanish-gray">&rarr;</span>
              {"  "}
              <span className="gilroy-bold text-orange-ryb">
                {about_overview_customer?.button_text}
              </span>
            </a>
          </div>
        </section>
        <section id="our-people" className="py-5">
          <div className="row">
            <div className="col-12 col-md-4">
              <img
                src={`${IMAGE_BASE_URL}/${about_overview_people?.image}`}
                loading="lazy"
                alt=""
                className="img-fluid d-block mb-5"
              />
            </div>
            <div className="col-12 col-md-8">
              <div className="mx-0 mx-md-4">
                <h2
                  className="fs-30 mb-5"
                  dangerouslySetInnerHTML={{
                    __html: about_overview_people?.title,
                  }}
                />
                <p
                  className="fs-16"
                  dangerouslySetInnerHTML={{
                    __html: about_overview_people?.description,
                  }}
                />
              </div>
            </div>
          </div>
        </section>
        {/* <p
          className="fs-16 my-5"
          dangerouslySetInnerHTML={{
            __html: about_overview_people?.footer,
          }}
        /> */}
      </section>
    </div>
  );
};

export default Overview;
